import {
  CONTENT_LOBBY_PAGE,
  JOBS_ONBOARDING_PAGE,
  JOBS_ONBOARDING_STEPSLUG_PAGE,
  ONBOARDING_V3_STEPSLUG_PAGE,
  CONNECTIONS_PAGE,
  CONNECTIONS_CONTACT_PAGE,
  CONNECTIONS_SYNC_PAGE,
  CONNECTIONS_STEPSLUG_PAGE,
  INDEX_PAGE,
  JOBS_MY_MATCHES_PAGE,
  WAIT_LIST_SKWSLUG_PAGE,
  WAIT_LIST_SKWSLUG_COMPLETE_PAGE,
  REFERRAL_PRE_ONBOARDING_PAGE,
} from '~/constants';

/**
 * @description Routes where we dont want to show mobile banner for downloading the app.
 */
export const invalidRoutes = [
  CONTENT_LOBBY_PAGE,
  JOBS_ONBOARDING_PAGE,
  JOBS_ONBOARDING_STEPSLUG_PAGE,
  ONBOARDING_V3_STEPSLUG_PAGE,
  CONNECTIONS_PAGE,
  CONNECTIONS_CONTACT_PAGE,
  CONNECTIONS_SYNC_PAGE,
  CONNECTIONS_STEPSLUG_PAGE,
  INDEX_PAGE,
  JOBS_MY_MATCHES_PAGE,
  WAIT_LIST_SKWSLUG_PAGE,
  WAIT_LIST_SKWSLUG_COMPLETE_PAGE,
  REFERRAL_PRE_ONBOARDING_PAGE,
];
